import allFields from '#/modules/alert/utils/fields';
import type { Alert } from '#/graphql/types';
import { RecordItem } from '#/common/components/RecordPreview';

export const fields: RecordItem<Alert>[] = [
  {
    items: [
      { ...allFields.displayNumber, gridOptions: { xs: 6, sm: 6, md: 3, lg: 3 } },
      { ...allFields.asset, gridOptions: { xs: 6, sm: 6, md: 3, lg: 3 } },
      { ...allFields.workOrder, gridOptions: { xs: 6, sm: 6, md: 3, lg: 3 } },
      { ...allFields.finding, gridOptions: { xs: 6, sm: 6, md: 3, lg: 3 } },
    ],
  },
  {
    items: [
      { ...allFields.exceptionName, gridOptions: { xs: 12 } },
      { ...allFields.state, gridOptions: { xs: 12, sm: 12, md: 4, lg: 4 } },
      { ...allFields.testValue, gridOptions: { xs: 6, sm: 6, md: 4, lg: 4 } },
      { ...allFields.daysFailed, gridOptions: { xs: 6, sm: 6, md: 4, lg: 4 } },
      { ...allFields.firstException, gridOptions: { xs: 6, sm: 6, md: 4, lg: 4 } },
      { ...allFields.lastException, gridOptions: { xs: 6, sm: 6, md: 4, lg: 4 } },
      { ...allFields.worstException, gridOptions: { xs: 6, sm: 6, md: 4, lg: 4 } },
      { ...allFields.impactComfort, gridOptions: { xs: 6, sm: 6, md: 4, lg: 4 } },
      { ...allFields.impactEnergy, gridOptions: { xs: 6, sm: 6, md: 4, lg: 4 } },
      { ...allFields.impactReliability, gridOptions: { xs: 6, sm: 6, md: 4, lg: 4 } },
      { ...allFields.suggestionDescription, gridOptions: { xs: 12, sm: 12, md: 12, lg: 12 } },
      { ...allFields.suggestionCauses, gridOptions: { xs: 12, sm: 12, md: 12, lg: 12 } },
    ],
  },
];
